import React, {Component} from 'react';
import ReportDipartimentiTabularRowView from './ReportDipartimentiTabularRowView'
import { Table } from 'semantic-ui-react'

class ReportDipartimentiTabularView extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let items = this.props.items;
        if (items === undefined){
            return null;
        }

        let tableData = null;
        let tableRows = [];
        let i = 0;
        if (items.length > 0){
            items.forEach((c) => {

                let row = (
                    <ReportDipartimentiTabularRowView item={c} key={i++} />
                )
                tableRows.push(row);
            });

            tableData = (
                <div className="ep-outer-table">
                    <div className="ep-inner-scrollable-table">
                        <Table celled compact={true} className="small">
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'id' ? this.state.direction:null} >
                                        ID
                                    </Table.HeaderCell>
                                    <Table.HeaderCell sorted={this.state.column === 'nome' ? this.state.direction : null} >
                                        Nome
                                    </Table.HeaderCell>
                                    <Table.HeaderCell sorted={this.state.column === 'organizzazione' ? this.state.direction : null} >
                                        Organizzazione
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'piva' ? this.state.direction : null} >
                                        PIVA - CF
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'indirizzo' ? this.state.direction : null} >
                                        Indirizzo
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'cap' ? this.state.direction:null} >
                                        CAP
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'citta' ? this.state.direction:null} >
                                        Città
                                    </Table.HeaderCell>
                                    <Table.HeaderCell  sorted={this.state.column === 'provincia' ? this.state.direction:null} >
                                        Provincia
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'stato' ? this.state.direction:null} >
                                        Stato
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'email' ? this.state.direction:null} >
                                        e-mail
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} sorted={this.state.column === 'pec' ? this.state.direction:null} >
                                        PEC
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true}  sorted={this.state.column === 'sito' ? this.state.direction:null} >
                                        Sito
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'cellulare' ? this.state.direction:null} >
                                        Cellulare
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'telefono1' ? this.state.direction:null} >
                                        Telefono 1
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'telefono2' ? this.state.direction:null} >
                                        Telefono 2
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'fax' ? this.state.direction:null} >
                                        Fax
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'creatoil' ? this.state.direction:null} >
                                        Creato il, da
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'modificatoil' ? this.state.direction:null} >
                                        Modificato il, da
                                    </Table.HeaderCell>
                                    <Table.HeaderCell collapsing={true} textAlign='left' sorted={this.state.column === 'note' ? this.state.direction:null} >
                                        Note
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {tableRows}
                            </Table.Body>
                        </Table>
                    </div>
                </div>
            )
        }
        return tableData
    }
}

export default ReportDipartimentiTabularView;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportDipartimentiTabularView.js
 **/